import numeral from "numeral";
import { iItemGameList } from "../pages/PulltabDecks/RawHtml";
import endpoints from "../utils/endpoints";
import { numberToCurrency, removeEmpty } from "../utils/objectUtils";
import { Api } from "./api";
import { notificationError, notificationSucces } from "./notification";


export async function getPulltabDecksList(params?: any) {
  let res = {
    error: false,
    message: '',
    error_migration: false,
    migration_message: '',
    location: {
      id: 0,
      name: "",
      closeAtBusinessDayEnd: false,
      closeAtMonthEnd: false,
      currentDate: "",
      status: ""
    },
    listGames: [
      {
        id: 0,
        title: "",
        image: "",
        gameAvailable: false,
        gameAvailableStart: "",
        gameAvailableEnd: "",
        listItemsGame: [{
          id: 0,
          wager: "",
          avaliable: false,
          autoCreate: false,
          autoClose: false,
          gameAutoCreate: false,
          gameAutoClose: false,
          form: "",
          tickets: 0,
          gameGroup: null,
          pivotForm: null,
          variant: "",
          serial: "",
          remaining: "",
          isClosing: false,
          gameAvailableStartSetting: false,
          gameAvailableStart: "",
          gameAvailableEndSetting: false,
          gameAvailableEnd: "",
          gameAvailable: false
        }]
      }
    ]
  }
  let validated = false

  if (params) {
    params = removeEmpty(params)
  }

  await Api.get(endpoints.getPulltabDecksList, { params }).then((response) => {
    if(response.status === 200) {
      if(response.data.error && !response.data.migration_message) {
        notificationError(`${response.data.message}`)
      } else {
        validated = true
        res = response.data
      }
    } else {
      notificationError('Could not get pull-tab decks list')
    }
    
  }).catch((err: string) => {
    notificationError('Could not get pull-tab decks list')
  })

  return res
}

export async function updatePulltabDecks(payload: any) {
  await Api.post(endpoints.updatePulltabDecks, payload).then((response) => {
    if(response.status === 200) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces('Pull-Tab Decks updated successfully')
      }
    } else {
      notificationError('Could not update Pull-Tab Decks')
    }
  }).catch((err: string) => {
    notificationError('Could not update Pull-Tab Decks')
  })
}
export async function closePulltabDeck(params: any, itemGame: iItemGameList, gameName: string) {
  const wager = numberToCurrency(itemGame.wager)
  const form = params.form;
  await Api.post(endpoints.closePulltabDecks, null, { params }).then((response) => {
    if(response.status === 200 && response.data.return ) {
      if(response.data.error) {
        notificationError(`${response.data.message}`)
      } else {
        notificationSucces(`Deck "${gameName} - ${wager}" (form ${form}) was successfully closed`)
      }
    } else {
      notificationError('Could not close Pull-Tab Decks')
    }
  }).catch((err: string) => {
    notificationError('Could not close Pull-Tab Decks')
  })
}